
import Vue from 'vue'
import './plugins/vuetify'
import App from '@/App.vue'
import router from '@/frontend/router'
import store from '@/frontend/store/store'
import Echo from 'laravel-echo'

Vue.config.productionTip = false;

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */



declare global {
    interface Window { Pusher: any; Echo: any; }
}

window.Pusher = require('pusher-js');

window.Echo = new Echo({
    broadcaster: 'pusher',
    key: 'fd88141282722d0b0ba4',
    cluster: 'eu',
    encrypted: true
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
